export default [
  'fabrication-offshore-whx',
  'fabrication-offshore-shenze',
  'fabrication-offshore-gt-pcb',
  'fabrication-offshore-fast-pcb',
];
